export default __webpack_public_path__ + "static/media/default.8ad48e51.svg";